import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IComponentController } from 'angular';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateParamsService } from 'angular-ui-router';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
interface IPageAl0003 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    valeursEcran: any;
    dliMultiOccurrence: IMultiOccurrence;
    dliMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dlhMultiOccurrence: IMultiOccurrence;
    dlhMultiOccurrenceOptions: IMultiOccurrenceOptions;
    dpiMultiOccurrence: IMultiOccurrence;
    dpiMultiOccurrenceOptions: IMultiOccurrenceOptions;
    ovdMultiOccurrenceOptions: IMultiOccurrenceOptions;

}

/* @ngInject */
export default function Al0003Controller(
    Formulaire: IFormulaireClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    FormulaireItem: IFormulaireItemClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    mr0176Route: IRoute,
    al2002Route: IRoute,
    al0002Route: IRoute,
    al0004Route: IRoute,
    al2006Route: IRoute,
    al2007Route: IRoute,
    MenuItemEcran: IMenuItemEcranClass,
    MenuItemForage: IMenuItemForageClass,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    Pagination: IPaginationClass,
    $stateParams: IStateParamsService
) {
    const vm: IPageAl0003 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    vm.monoOccurrenceOptions = {
        fonctions: {
            importation: false
        }
    };

    vm.formulaire = new Formulaire('LBL_BLC', [
        new FormulaireItem('prfcleint', { modifAllow: false, largeur: 40 }),
        new FormulaireItem('dlpdatdeb', { largeur: 10 }),
        new FormulaireItem('dlpdatfin', { largeur: 10 }),
        new FormulaireItem('dalcleint', { default: $stateParams.dalcleint }),
        new FormulaireItem('dlpseqmod', { largeur: 15, default: vm.valeursEcran.dalseqmodcou }),

        new FormulaireItem('dlpflgact', { largeur: 15, default: 1 }),
        new FormulaireItem('t_dlpflgact', { largeur: 15, default: (data: any) => data.dlpflgact }),
        new FormulaireGroupeAccordeon('LBL_ACC_DOC',
            new Formulaire([
                new FormulaireItem('t_alddoc', { largeur: 100, titre: ' ', default: vm.valeursEcran.alddoc })]))
    ]);
    vm.btnMenus = [
        new MenuItemForage(
            'LBL_ALD',
            al0002Route.NAME,
            () => ({
                id: vm.monoOccurrence.data.trncleintald
            }),
            {
                iconButton: false,
                icon: 'view_list',
                fonction: 'BOUIMP',
                hidden: !vm.valeursEcran.objflgseg
            }
        ),
        new MenuItemForage(
            'LBL_BTN_CAL',
            al2006Route.NAME,
            (data: any) => ({
                id: vm.monoOccurrence.id,
                axe_actif: 'list'
            }),
            {
                icon: '',
                fonction: 'BOUCAL',
                iconButton: false,
                secondaire: true,
                hidden: vm.valeursEcran.flgcal
            }
        )
    ];
    // Dates.
    vm.dliMultiOccurrenceOptions = {
        bloc: 'dli',
        fonctions: {
            importation: true
        },
        colonnesCachees: [
            'vaedlitypdatald_cod',
            'dlicleint'
        ],
        actionsMoreLigne: new Menu([
            new MenuItemForage('LBL_CAR',
                al2002Route.NAME,
                (data: any) => ({
                    id: data.dlicleint,
                    dalseqmodcou: $stateParams.dalseqmodcou,
                    ecldsceta: $stateParams.ecldsceta,
                    dliseqmod: data.dliseqmod

                }),
                {
                    icon: 'view_list',
                    disabled: (data: any) => data.vaedlitypdatald_cod != 'CAR',
                    iconButton: false
                }),
            new MenuItemAction('LBL_BOUGEN', 'BOUGEN', () => ({}), {
                icon: 'sync',
                saveFirst: true,
                disabled: (data: any) => vm.valeursEcran.vaeceptypmod === 'AUC' || !data.dliflgact || data.flgacc,
                successAction: () => {
                    vm.dlhMultiOccurrence.fetchDataList();
                }
            }),
            new MenuItemAction('LBL_BOUCOP', 'BOUCOP', () => ({}), {
                saveFirst: true,
                icon: 'content_copy',
                disabled: (data: any) => vm.valeursEcran.vaeceptypmod === 'AUC' || data.flgacc,
                successAction: () => {
                    vm.dliMultiOccurrence.fetchDataList();
                }
            })
        ]),
        formulaire: new Formulaire([
            new FormulaireItem('vaedlitypdatald', {
                largeur: 20,
                default: vm.valeursEcran.vaedlitypdatald,
                resourceParams: () => ({
                    prfcleint: vm.monoOccurrence.data.prfcleint
                })
            }),
            new FormulaireItem('vaedlimodgen', { largeur: 20, hidden: vm.valeursEcran.flgcal }),
            new FormulaireItem('dlidatdeb', { largeur: 20 }),
            new FormulaireItem('dlidatfin', { largeur: 20 }),
            new FormulaireItem('t_dlidatfin', { default: (data: any) => data.dlidatfin }),
            new FormulaireItem('nbrjrs', {
                largeur: 20,
                default: (data: any) => (data.$id && vm.dliMultiOccurrence.getDataActiveRow() ? vm.dliMultiOccurrence.getDataActiveRow().nbrjrs : null)
            }),
            new FormulaireItem('dlicom', { largeur: 20 }),
            new FormulaireItem('dliflgbal', { largeur: 20 }),
            new FormulaireItem('dliseqmod', { largeur: 20, default: vm.valeursEcran.dalseqmodcou }),
            new FormulaireItem('dliflgact', { largeur: 20, default: 1 }),
            new FormulaireItem('t_dliflgact', { default: (data: any) => data.dliflgact })
        ]),
        colonnesVisibles: [
            { nom: 'vaedlitypdatald', largeur: 158 },
            { nom: 'vaedlimodgen_dsc', largeur: 118, hidden: vm.valeursEcran.flgcal },
            { nom: 'dlidatdeb', largeur: 100 },
            { nom: 'dlidatfin', largeur: 100 },
            { nom: 'nbrjrs', largeur: 85 },
            { nom: 'dlicom', largeur: 155 },
            { nom: 'dliflgbal', largeur: 100, hidden: vm.valeursEcran.flgcal },
            { nom: 'dliseqmod', largeur: 80 },
            { nom: 'dliflgact', largeur: 100 }
        ]
    };
    // Horaire
    vm.dlhMultiOccurrenceOptions = {
        bloc: 'dlh',
        actionsNouveaux: new Menu([
            new MenuItemForage(
                'G_LBL_BTN_NOUVEAU',
                () => getForageItem(),
                () => getForageParams(),
                {
                    disabled: () => vm.valeursEcran.vaeprftyp === 'ADIF' || vm.valeursEcran.vaeceptypmod === 'AUC' || vm.valeursEcran.flgoff
                }
            )
        ]),
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                'G_LBL_BTN_OUVRIR',
                () => getForageItem(),
                (rowData: any) => getForageParams(rowData),
                {
                    icon: 'launch',
                    fonction: 'BOUOUV'
                }
            )
        ]),
        colonnesVisibles: [
            { nom: 'dlhdatvig', largeur: 100 },
            { nom: 'dlhpctrep', largeur: 137 },
            { nom: 'dlhcom', largeur: 250 },
            { nom: 'dlhtauhor', largeur: 100 },
            { nom: 'dlhseqmod', largeur: 80 },
            { nom: 'dlhflgact', largeur: 100 }
        ]

    };
    // Indemnité
    vm.dpiMultiOccurrenceOptions = {
        bloc: 'dpi',
        fonctions: {
            importation: true,
            nouveau: !vm.valeursEcran.flgoff,
            edition: !vm.valeursEcran.flgoff
        },
        formulaire: new Formulaire([
            new FormulaireItem('tagcleint', {
                largeur: 50,
                resourceParams: () => ({
                    prfcleint: vm.monoOccurrence.data.prfcleint,
                    dlpdatdeb: vm.monoOccurrence.data.dlpdatdeb
                })
            }),
            new FormulaireItem('dpidatvig', { largeur: 25 }),
            new FormulaireItem('dpidatfin', { largeur: 25 }),
            new FormulaireItem('t_dpidatfin', { default: (data: any) => data.dpidatfin }),
            new FormulaireItem('dpiqte', { largeur: 33.33 }),
            new FormulaireItem('dpimnt', { largeur: 33.33 }),
            new FormulaireItem('dpiflgact', { largeur: 33.33, default: 1 }),
            new FormulaireItem('t_dpiflgact', { default: (data: any) => data.dpiflgact }),
            new FormulaireItem('dpiseqmod', { largeur: 20, default: vm.valeursEcran.dalseqmodcou })
        ]),
        colonnesVisibles: [
            { nom: 'tagcod', largeur: 100 },
            { nom: 'tagdsc', largeur: 280 },
            { nom: 'dpidatvig', largeur: 100 },
            { nom: 'dpidatfin', largeur: 100 },
            { nom: 'dpiqte', largeur: 140 }
        ],
        colonnesFixesDroite: [
            { nom: 'dpimnt', largeur: 126 },
            { nom: 'dpiseqmod', largeur: 80 },
            { nom: 'dpiflgact', largeur: 100 }
        ]
    };


    ///////////////////
    // Imputation - Affectation
    ///////////////////
    vm.ovdMultiOccurrenceOptions = {
        resourceParams: {
            ovdcleintref: vm.valeursEcran.dlpcleint,
            stamnetab: 'DLP'
        },
        actionsRangeeDroite: new Menu([
            new MenuItemEcran('BTN_MODIFIER', mr0176Route.NAME, (rowData: any) => {
                return {
                    id: rowData.ovdcleint,
                    ovdcleintref: vm.valeursEcran.dlpcleint,
                    stamnetab: 'DLP',
                };
            }, {
                icon: 'launch',
                fonction: 'BOUOUV',
                disabled: !vm.valeursEcran.dlpcleint
            })
        ]),
        actionsNouveaux: new Menu([
            new MenuItemEcran('G_LBL_BTN_NOUVEAU', mr0176Route.NAME, (rowData: any) => {
                return {
                    ovdcleintref: vm.valeursEcran.dlpcleint,
                    stamnetab: 'DLP',
                };
            }, {
                fonction: 'BOUNOUV',
                disabled: !vm.valeursEcran.dlpcleint,
            })
        ]),
        bloc: 'ovd',
        fonctions: {
            pagination: true,
            criteresSuggeresVisibles: false,
            criteresRechercheOpened: false
        },
        pagination: new Pagination({
            nombreElementPage: 3,
            nbElementsPossibles: [3, 6, 15]
        }),
        criteresSuggeres: new Formulaire([
            new FormulaireItem('selection', {
                largeur: 100,
                default: 'VF',
                direction: 'vertical'
            })
        ]),
        // Affichage des colonnes visibles
        colonnesVisibles: [
            { nom: 'ovnimp', largeur: 300 },
            { nom: 'rsccoddsc', largeur: 100 },
            { nom: 'ovddatvig', largeur: 100 },
            { nom: 'ovddatfin', largeur: 100 }
        ],
        colonnesCachees: [
            'ovdcleint'
        ]
    };
    function getForageItem(): string {
        if (!vm.valeursEcran.flgcal) {
            return al2007Route.NAME;
        } else {
            return al0004Route.NAME;
        }
    }

    function getForageParams(rowData?: any): any {
        if (!vm.valeursEcran.flgcal) {
            if (rowData) {
                return {
                    id: rowData.dlhcleint,
                    dlpcleint: vm.monoOccurrence.data.dlpcleint
                };
            } else {
                return {
                    dlpcleint: vm.monoOccurrence.data.dlpcleint
                };
            }
        } else {
            if (rowData) {
                return {
                    id: rowData.dlhcleint,
                    dlpcleint: vm.monoOccurrence.data.dlpcleint,
                    dalcleint: $stateParams.dalcleint,
                    tdlcleint: $stateParams.tdlcleint
                };
            } else {
                return {
                    dlpcleint: vm.monoOccurrence.data.dlpcleint,
                    prfcleint: vm.monoOccurrence.data.prfcleint,
                    dalcleint: $stateParams.dalcleint
                };
            }
        }
    }
}
